module.exports = {
  siteMetadata: {
    title: 'Hutch',
    description: 'An award-winning game development studio',
    siteUrl: 'https://hutch.io',
    author: '@hutchgames',
    baseUrl: 'https://hutch.io',
    postAuthor: 'Hutch',
  },
  pathPrefix: '/',
  plugins: [
    {
      resolve: `gatsby-source-storyblok`,
      options: {
        accessToken: `SbfKGJKXeF0USUQ9C3Tingtt`,
        // accessToken: `DCxq2V6yS4oheV5mbzVSVQtt`,
        homeSlug: `home`,
        resolveLinks: 'url',
        resolveRelations: [
          'homepage.game_spotlight',
          'our_games.primary_games.game_link',
          'our_games.secondary_games.game_link',
          'layout.footer_links',
        ],
        includeLinks: true,
        version: process.env.NODE_ENV === `production` ? `published` : `draft`,
      },
    },
    {
      resolve: `gatsby-plugin-manifest`,
      options: {
        name: 'Hutch',
        short_name: 'Hutch',
        description: 'An award-winning game development studio',
        homepage_url: 'https://hutch.io',
        start_url: '/',
        background_color: '#0F0F0F',
        theme_color: '#FEC200',
        display: 'standalone',
        icon: 'src/icons/icon.svg',
      },
    },
    {
      resolve: `gatsby-plugin-gdpr-cookies`,
      options: {
        googleAnalytics: {
          trackingId: 'UA-47631299-11', // leave empty if you want to disable the tracker
          cookieName: 'hutch-gdpr-google-analytics', // default
          anonymize: true, // default
          allowAdFeatures: false, // default
        },
        googleTagManager: {
          trackingId: '', // leave empty if you want to disable the tracker
          cookieName: 'hutch-gdpr-google-tagmanager', // default
          dataLayerName: 'dataLayer', // default
        },
        facebookPixel: {
          pixelId: '', // leave empty if you want to disable the tracker
          cookieName: 'hutch-gdpr-facebook-pixel', // default
        },
        // defines the environments where the tracking should be available  - default is ["production"]
        environments: ['production', 'development'],
      },
    },
    {
      resolve: `gatsby-plugin-google-fonts`,
      options: {
        fonts: [
          `Montserrat:ital,wght@0,300;0,400;0,500;0,700;0,900;1,300;1,400;1,700;1,900`,
        ],
        display: 'swap',
      },
    },
    {
      resolve: 'gatsby-plugin-netlify',
      options: {
        headers: {
          '/*': [
            'Content-Security-Policy: frame-ancestors https://app.storyblok.com/',
          ],
        },
        mergeSecurityHeaders: true,
        mergeLinkHeaders: true,
        mergeCachingHeaders: true,
      },
    },
    {
      resolve: `gatsby-plugin-scroll-reveal`,
      options: {
        threshold: 0.5, // Percentage of an element's area that needs to be visible to launch animation
        once: true, // Defines if animation needs to be launched once
        disable: false, // Flag for disabling animations

        // Advanced Options
        selector: '[data-sal]', // Selector of the elements to be animated
        animateClassName: 'sal-animate', // Class name which triggers animation
        disabledClassName: 'sal-disabled', // Class name which defines the disabled state
        rootMargin: '0% 50%', // Corresponds to root's bounding box margin
        enterEventName: 'sal:in', // Enter event name
        exitEventName: 'sal:out', // Exit event name
      },
    },
    {
      resolve: `gatsby-plugin-force-trailing-slashes`,
    },
    {
      resolve: `gatsby-plugin-sitemap`,
      options: {
        exclude: [`/editor`],
        query: `
        {
          site {
            siteMetadata {
              siteUrl
            }
          }
          allSitePage {
            edges {
              node {
                path
                context {
                  story {
                    id
                    content
                  }
                }
              }
            }
          }
      }`,
        serialize: ({ site, allSitePage }) =>
          allSitePage.edges.map((edge) => {
            let path = edge.node.path;
            let pageData;
            if (
              edge.node &&
              edge.node.context &&
              edge.node.context.story &&
              edge.node.context.story.content
            ) {
              pageData = JSON.parse(edge.node.context.story.content);
            }
            let priority = 0.7;
            let frequency = `daily`;
            if (path.match('/our-story/')) {
              priority = 0.7;
              frequency = `daily`;
            } else if (path.match('/our-people/')) {
              priority = 0.7;
              frequency = `daily`;
            } else if (path.match('/our-games/')) {
              priority = 0.7;
              frequency = `daily`;
            } else if (path.match('/news/')) {
              priority = 0.7;
              frequency = `daily`;
            } else if (path.match('/careers/')) {
              priority = 0.7;
              frequency = `daily`;
            } else if (path.match('/contact-us/')) {
              priority = 0.7;
              frequency = `daily`;
            } else if (path.match('/how-we-handle-your-data/')) {
              priority = 0.7;
              frequency = `daily`;
            } else if (path.match('/terms-of-service/')) {
              priority = 0.7;
              frequency = `daily`;
            } else if (path.match('/privacy/')) {
              priority = 0.7;
              frequency = `daily`;
            }

            // Override if there is metadata for it
            let metaPriority = priority;
            /*
            if (
              pageData &&
              pageData.sitemap_priority &&
              !isNaN(pageData.sitemap_priority)
            ) {
              metaPriority = parseFloat(pageData.sitemap_priority).toFixed(1);
            }
            */
            // Override if there is metadata for it
            let metaFrequency = frequency;
            if (pageData && pageData.sitemap_frequency) {
              metaFrequency = pageData.sitemap_frequency;
            }

            console.log(
              'priority: ',
              metaPriority,
              '    path: ',
              path,
              '    frequency:',
              metaFrequency,
            );

            return {
              url: site.siteMetadata.siteUrl + edge.node.path,
              changefreq: metaFrequency,
              priority: metaPriority,
            };
          }),
      },
    },
    'gatsby-plugin-catch-links',
    'gatsby-plugin-react-helmet',
    'gatsby-plugin-sass',
    'gatsby-plugin-sharp',
    'gatsby-transformer-sharp',
    'gatsby-plugin-preact',
  ],
};
